module.exports = __webpack_public_path__ + "static/media/QA.2b194a9d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/QA.svg
// module id = 346
// module chunks = 0